import React, { useMemo, useState, useEffect } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import PageLayout from "../../Components/Common/PageLayout";
import CardLayout from "../../Components/Common/CardLayout";
import TextInput from "../../Components/Common/FormInputs/TextInput";
import TextArea from "../../Components/Common/FormInputs/TextArea";
import { DatePicker, SelectDropdown } from "../../Components/Common/FormInputs";
import CustomButton from "../../Components/Common/FormInputs/CustomButton";
import { useTask } from "../../hooks/useTask";
import useHrisSettings from "../../hooks/useHrisSettings";
// import useReport from "../../hooks/useReport";
import { useSelector } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { useLocation } from "react-router-dom";
import useChecklist from "../../hooks/useChecklist";

dayjs.extend(weekOfYear);


const WORKING_HOURS_PER_DAY = 8;



const STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "submitted", label: "Submitted" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

const INITIAL_ROWS = [
  { id: "row-1", projectId: "", wbseId: "", taskId: "" },
  { id: "row-2", projectId: "", wbseId: "", taskId: "" },
];

const TimesheetHeader = ({ days, today, isHoliday, isWeekOff, isSunday }) => (
  <thead>
    <tr>
      <th style={{ minWidth: 150 }}>Select Project</th>
      <th style={{ minWidth: 350 }}>WBSE & Task</th>
      {days.map((date) => {
        // const isNonWorking =
        //   isSunday(date) || isHoliday(date) || isWeekOff(date);

        const sunday = isSunday(date);
        const holiday = isHoliday(date) || isWeekOff(date);

        return (
          <th
            key={date.format("DD")}
            style={{
              minWidth: 70,
              background: date.isSame(today, "day")
                ? "#e6f3ff"
                : sunday
                  ? "#f0baaa"
                  : holiday
                    ? "#f2f2f2"
                    : "",
              textAlign: "center",
            }}
          >
            <div>{date.format("DD")}</div>
            <div style={{ fontSize: 12, color: "#666" }}>
              {date.format("ddd")}
            </div>
          </th>
        );
      })}
    </tr>
  </thead>
);

const TimesheetRow = ({
  row,
  days,
  entries,
  projectOptions,
  onChange,
  onRowMetaChange,
  isCellDisabled,
  isHoliday,
  isLeave,
  isOptionalHoliday,
  dayTypes,
  isSunday,
  sundayOverrides,
  holidayOverrides,
  onSundayClick,
  handleHolidayClick,
  onRemoveRow,
  canEdit,
  isSupervisorViewingOther,
  onDeleteRow,
  setDeletedRows

}) => {
  const { gettaskDropdown } = useTask();
  const { data: wbseData } = gettaskDropdown(row.projectId);

  // const [deletedRows, setDeletedRows] = useState([]);



  // const wbseList = useMemo(() => {
  //   if (Array.isArray(wbseData?.data)) {
  //     return wbseData.data.map((item) => ({
  //       label: item.label,
  //       value: item.wbse_id,
  //     }));
  //   }

  //   if (Array.isArray(wbseData?.data?.result)) {
  //     return wbseData.data.result.map((item) => ({
  //       label: item.title,
  //       value: item.wbse_id,
  //     }));
  //   }

  //   return [];
  // }, [wbseData]);

  const wbseList = useMemo(() => {

    if (Array.isArray(wbseData?.data?.result)) {
      return wbseData.data.result.map(item => ({
        label: `${item.wbse_name} - ${item.task_name}`,
        value: `${item.wbse_id}_${item.task_id}`,
        wbse_id: item.wbse_id,
        task_id: item.task_id
      }));
    }

    return [];

  }, [wbseData]);

  console.log(wbseList, "wbselist");
  return (
    <tr>
      <td>
        <SelectDropdown
          name="projectId"
          value={row.projectId}
          values={{ projectId: row.projectId }}
          options_data={projectOptions}
          setValues={(nextValues) =>
            onRowMetaChange(row.id, "projectId", nextValues.projectId)
          }
          isDisabled={!canEdit}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
        {/* <span
    style={{ cursor: "pointer", color: "red", fontWeight: "bold" }}
    onClick={() => onRemoveRow(row.id)}
  > X</span> */}
      </td>
      <td>
        {/* <SelectDropdown
          name="wbseId"
          value={row.wbseId}
          values={{ wbseId: row.wbseId }}
          options_data={wbseList}
          setValues={(nextValues) =>
            onRowMetaChange(row.id, "wbseId", nextValues.wbseId)
          }
          isDisabled={!row.projectId}
        /> */}
        <SelectDropdown
          name="wbseTask"
          value={`${row.wbseId}_${row.taskId}`}
          values={{ wbseTask: `${row.wbseId}_${row.taskId}` }}
          options_data={wbseList}
          setValues={(nextValues) => {

            const selected = wbseList.find(
              item => item.value === nextValues.wbseTask
            );

            onRowMetaChange(row.id, "wbseId", selected.wbse_id);
            onRowMetaChange(row.id, "taskId", selected.task_id);

          }}
          isDisabled={!canEdit || !row.projectId}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </td>

      {days.map((date) => {
        const dateKey = date.format("YYYY-MM-DD");
        const disabled = isCellDisabled(date);   // ✅ ADD THIS BACK

        return (
          <td
            key={`${row.id}-${dateKey}`}
            style={{
              background:
                dayTypes?.[dateKey] === "leave"
                  ? "#d0ebff"
                  : dayTypes?.[dateKey] === "holiday"
                    ? "#f2f2f2"
                    : isSunday(date)
                      ? "#f0baaa"
                      : ""
            }}
          >
            <TextInput
              // type="number"
              min="0"
              readOnly={
                isSunday(date) &&
                !sundayOverrides?.[dateKey]
              }
              // disabled={!canEdit || isCellDisabled(date)}
              disabled={!canEdit || disabled || isSupervisorViewingOther}
              // value={entries?.[row.id]?.[dateKey] ?? ""}
              value={entries?.[row.id]?.[dateKey]?.hours ?? ""}
              onClick={() => {
                if (
                  isSunday(date) &&
                  !sundayOverrides?.[dateKey]
                ) {
                  onSundayClick(date);
                }
                // if (isOptionalHoliday(date) && !holidayOverrides?.[dateKey]) {
                //   handleHolidayClick(date);
                // }
              }}
              onChange={(e) => onChange(row.id, date, e.target.value)}
            />
          </td>

        );

      })}
      <td style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <span
          style={{ cursor: "pointer", color: "red", fontWeight: "bold" }}
          // onClick={() => canEdit && onRemoveRow(row.id)}
          onClick={() => {
            if (!canEdit) return;

            const rowEntries = entries?.[row.id] || {};

            const idsToDelete = Object.values(rowEntries)
              .map(e => e?.timesheet_id)
              .filter(Boolean);

            // ✅ update parent state properly
            setDeletedRows(prev => [...new Set([...prev, ...idsToDelete])]);

            // ✅ remove row
            onRemoveRow(row.id);
          }}
        > X</span>
      </td>
    </tr>
  );
};

const TimesheetDayTypeRow = ({ days, dayTypes, onChange }) => (
  <tr>
    <td colSpan={2}>Day Type</td>
    {days.map((date) => {
      const dateKey = date.format("YYYY-MM-DD");

      return (
        <td key={dateKey}>
          <select
            className="form-control form-control-sm"
            value={dayTypes[dateKey] || ""}
            onChange={(e) => onChange(date, e.target.value)}
          >
            <option value="">--</option>
            <option value="leave">Leave</option>
            <option value="holiday">Holiday</option>
            <option value="optional">Optional Holiday</option>
          </select>
        </td>
      );
    })}
  </tr>
);

const TimesheetTotals = ({
  days,
  calculateDayTotal,
  dayTypes,
  isLeave,
  isHoliday,
  isSunday,
  isWeekOff,
}) => (
  <tr>
    <td colSpan={2}>Total hours worked per day</td>
    {days.map((date) => {
      const dateKey = date.format("YYYY-MM-DD");
      const total = calculateDayTotal(date);
      const isLeaveDay = isLeave(date);
      const isNonWorking = isSunday(date) || isHoliday(date) || isWeekOff(date);

      let dotColor = "#ccc";
      if (dayTypes?.[dateKey] === "leave") dotColor = "#007bff";
      else if (total === 0) dotColor = "#ccc";
      else if (total < WORKING_HOURS_PER_DAY) dotColor = "red";
      else dotColor = "green";

      return (
        <td
          key={`total-${date.format("YYYY-MM-DD")}`}
          style={{ background: isNonWorking ? "#f2f2f2" : "" }}
        >
          <div style={{ textAlign: "center" }}>{total}</div>
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: dotColor,
              margin: "auto",
              marginTop: 4,
            }}
          />
        </td>
      );
    })}
  </tr>
);

// const TimesheetCommentsRow = ({ days, dailyComments, onOpen }) => (
//   <tr>
//     {/* <td colSpan={2}>Daily Comments</td> */}
//     {days.map((date) => {
//       const dateKey = date.format("YYYY-MM-DD");
//       const hasComment = !!dailyComments[dateKey];

//       return (
//         <td
//           key={`comment-${dateKey}`}
//           style={{ textAlign: "center", cursor: "pointer" }}
//           onClick={() => onOpen(date)}
//         >
//           <span
//             style={{
//               fontSize: 18,
//               color: hasComment ? "green" : "#999",
//             }}
//           >
//             💬
//           </span>
//         </td>
//       );
//     })}
//   </tr>
// );

const TimesheetPage = () => {
  const today = dayjs();

  const [selectedMonth, setSelectedMonth] = useState(today);
  const [weekOffset, setWeekOffset] = useState(0);

  const [currentWeekStart, setCurrentWeekStart] = useState(
    dayjs().startOf("week").add(1, "day")
  );
  const [searchParams] = useSearchParams();
  const userIdFromParams = searchParams.get("user_id");
  const [userName, setUserName] = useState("");

const location = useLocation();
const passedUserName = location.state?.user_name;


  const week = searchParams.get("week");
  const year = searchParams.get("year");
  const profile_Details = useSelector(state => state.globalslice.profile_Details);

  const approveAccess = profile_Details?.group?.some(
    ele => ele.slug === "hr" || ele.slug === "super-admin" || ele.slug === "supervisor" || ele.slug === "manager" || ele.slug === "superviser"
  );
  const loggedInUserId = profile_Details?.id;

  const [deletedRows, setDeletedRows] = useState([]);

  // user_id returned from API timesheet rows


  //DEFINE THIS HERE (EARLY)
  const monthKey = selectedMonth.format("YYYY-MM");
  const {getProjectDropdown} = useChecklist();
  const {addTimesheet, getTimesheetList, approveTimesheet, getHolidaysListTask } = useTask();

  // const { getHolidaysList } = useHrisSettings();
  // const { getStaffLeaveList } = useReport();
  const [sundayOverrides, setSundayOverrides] = useState({});
  const [dayTypes, setDayTypes] = useState({});
  const [holidayOverrides, setHolidayOverrides] = useState({});
  const [dailyComments, setDailyComments] = useState({});
  const [commentModal, setCommentModal] = useState({
    isOpen: false,
    dateKey: null,
  });
  const daysArray = useMemo(() => {
    return Array.from({ length: 7 }, (_, i) =>
      currentWeekStart.add(i, "day")
    );
  }, [currentWeekStart]);
  // getHolidaysListTask
  const weekStart = daysArray[0].format("YYYY-MM-DD");
  const weekEnd = daysArray[6].format("YYYY-MM-DD");

  const { data: timesheetData } = getTimesheetList(weekStart, weekEnd, userIdFromParams);

  useEffect(() => {
  if (passedUserName) {
    setUserName(passedUserName);
  }
}, [passedUserName]);

  const [currentComment, setCurrentComment] = useState("");
  const [timesheet, setTimesheet] = useState({
    entries: {},
    status: "draft",
    rows: INITIAL_ROWS,
    description: ""
  });
  // const { data: projectData } = getProjectDropdown();
  // const { data: holidaysData } = getHolidaysList(monthKey);
  // const { data: holidaysData } = getHolidaysListTask(monthKey);
  // const { data: leaveData } = getStaffLeaveList(monthKey);

  const timesheetOwnerId = timesheetData?.data?.result?.[0]?.user_id;

  // const isOwner = !timesheetOwnerId || loggedInUserId === timesheetOwnerId;
  const isOwner =
    !userIdFromParams ||
    Number(userIdFromParams) === loggedInUserId;

  // const canEditTimesheet = !approveAccess || isOwner;

  const timesheetStatus = timesheetData?.data?.result?.[0]?.timesheet_status;
  const isSubmitted = timesheetStatus === "submitted";
  const isApproved = timesheetData?.data?.result?.[0]?.approval_status === "approved";

  // ✅ FINAL EDIT CONTROL
  const canEditTimesheet =
    isOwner && !isSubmitted && !isApproved;

  // const canEditTimesheet =
  //   (!approveAccess && isOwner) || // normal user
  //   (approveAccess && isOwner);    // supervisor editing own

  const isSupervisorViewingOther =
    approveAccess && !isOwner;

  const canApprove =
    isSupervisorViewingOther &&
    timesheetStatus === "submitted";


  // const projectOptions = useMemo(
  //   () =>
  //     projectData?.data?.map((item) => ({
  //       label: item.project_name,
  //       value: item.project_id,
  //     })) || [],
  //   [projectData]
  // );
   const { isLoading: projectLoading, data: ProjectData } = getProjectDropdown();
const projectOptions =
    ProjectData?.data?.result?.map((item) => ({
      label: item.project_name,
      value: item.project_id,
    })) || [];

  // const holidays = useMemo(
  //   () => holidaysData?.data?.map((item) => item.holiday_date) || [],
  //   [holidaysData]
  // );
  // const holidays = useMemo(() => {
  //   if (Array.isArray(holidaysData?.data)) {
  //     return holidaysData.data.map(item => ({
  //       date: item.holiday_date,
  //       type: item.type || "mandatory",
  //     }));
  //   }

  //   if (Array.isArray(holidaysData?.data?.result)) {
  //     return holidaysData.data.result.map(item => ({
  //       date: item.holiday_date,
  //       type: item.type || "mandatory",
  //     }));
  //   }
  //   return [];
  // }, [holidaysData]);

  const userWeekOffs = useMemo(() => ["2026-03-15"], []);
  // const leaveDates = useMemo(
  //   () => leaveData?.data?.map((item) => item.leave_date) || [],
  //   [leaveData]
  // );
  // const leaveDates = useMemo(() => {
  //   if (Array.isArray(leaveData?.data)) {
  //     return leaveData.data.map(item => item.leave_date);
  //   }

  //   if (Array.isArray(leaveData?.data?.result)) {
  //     return leaveData.data.result.map(item => item.leave_date);
  //   }

  //   return [];
  // }, [leaveData]);

  const daysInMonth = selectedMonth.daysInMonth();


  const isFuture = (date) => {
    return date.isAfter(today, "day") && date.isSame(today, "month");
  };

  const handleDayTypeChange = (date, value) => {
    const dateKey = date.format("YYYY-MM-DD");

    setDayTypes(prev => ({
      ...prev,
      [dateKey]: value
    }));
  };

  const isOptionalHoliday = (date) =>
    dayTypes[date.format("YYYY-MM-DD")] === "optional";

  // const isHoliday = (date) =>
  //   holidays.some(h => h.date === date.format("YYYY-MM-DD"));
  const isHoliday = (date) =>
    dayTypes[date.format("YYYY-MM-DD")] === "holiday";

  const isWeekOff = (date) => userWeekOffs.includes(date.format("YYYY-MM-DD"));

  // const isLeave = (date) => leaveDates.includes(date.format("YYYY-MM-DD"));
  const isLeave = (date) =>
    dayTypes[date.format("YYYY-MM-DD")] === "leave";

  const isSunday = (date) => date.day() === 0;

  const isCellDisabled = (date) => {
    const dateKey = date.format("YYYY-MM-DD");
    if (isFuture(date)) return true;
    // if (isLeave(date)) return true;
    // if (isHoliday(date) && !holidayOverrides[dateKey]) return true;
    if (dayTypes[dateKey] === "leave") return true;
    if (dayTypes[dateKey] === "holiday") return true;
    if (dayTypes[dateKey] === "optional") return true;
    if (isWeekOff(date)) return true;

    // Sunday is NOT disabled here
    return false;
  };

  const handleSundayClick = (date) => {
    const dateKey = date.format("YYYY-MM-DD");

    if (sundayOverrides[dateKey]) return;
    const confirmWork = window.confirm("Did you work on Sunday?");
    if (confirmWork) {
      setSundayOverrides((prev) => ({
        ...prev,
        [dateKey]: true,
      }));
    }
  };

  const handleHolidayClick = (date) => {
    const dateKey = date.format("YYYY-MM-DD");

    if (holidayOverrides[dateKey]) return;

    const confirmWork = window.confirm("Do you want to work on this holiday?");
    if (confirmWork) {
      setHolidayOverrides(prev => ({
        ...prev,
        [dateKey]: true
      }));
    }
  };

  const handleAddRow = () => {
    const newRowId = `row-${Date.now()}`;

    setTimesheet((prev) => ({
      ...prev,
      rows: [
        ...prev.rows,
        {
          id: newRowId,
          projectId: "",
          wbseId: "",
          taskId: "",
        },
      ],
    }));
  };

  const handleRemoveRow = (rowId) => {
    setTimesheet((prev) => ({
      ...prev,
      rows: prev.rows.filter((row) => row.id !== rowId),
    }));
  };
  const handleDeleteRow = (rowId, rowEntries) => {
    const ids = Object.values(rowEntries || {})
      .map(e => e?.timesheet_id)
      .filter(Boolean);

    setDeletedRows(prev => [...new Set([...prev, ...ids])]);

    handleRemoveRow(rowId);
  };
  const handleRowMetaChange = (rowId, field, value) => {
    setTimesheet((prev) => ({
      ...prev,
      rows: prev.rows.map((row) => {
        if (row.id !== rowId) return row;

        if (field === "projectId") {
          return { ...row, projectId: value, wbseId: "", taskId: "" };
        }

        if (field === "wbseId") {
          return { ...row, wbseId: value, taskId: value };
        }

        return { ...row, [field]: value };
      }),
    }));
  };

  // const handleChange = (rowId, day, value) => {
  //   const formattedDay = day.format("YYYY-MM-DD");

  //   setTimesheet((prev) => ({
  //     ...prev,
  //     entries: {
  //       ...prev.entries,
  //       [rowId]: {
  //         ...prev.entries[rowId],
  //         [formattedDay]: {
  //           timesheet_id:
  //             prev.entries?.[rowId]?.[formattedDay]?.timesheet_id || 0,
  //           hours: value === "" ? "" : Math.max(0, Number(value)),
  //         },
  //       },
  //     },
  //   }));
  // };

  const handleChange = (rowId, day, value) => {
    const formattedDay = day.format("YYYY-MM-DD");

    setTimesheet((prev) => {
      const existingEntry =
        prev.entries?.[rowId]?.[formattedDay];

      // ✅ IF CLEARED → ADD TO DELETE LIST
      if (value === "" || value === null) {
        if (existingEntry?.timesheet_id) {
          setDeletedRows(prevIds =>
            [...new Set([...prevIds, existingEntry.timesheet_id])]
          );
        }

        return {
          ...prev,
          entries: {
            ...prev.entries,
            [rowId]: {
              ...prev.entries[rowId],
              [formattedDay]: {
                timesheet_id: existingEntry?.timesheet_id || 0,
                hours: ""
              }
            }
          }
        };
      }

      // ✅ NORMAL CASE
      let num = Number(value);



      return {
        ...prev,
        entries: {
          ...prev.entries,
          [rowId]: {
            ...prev.entries[rowId],
            [formattedDay]: {
              timesheet_id: existingEntry?.timesheet_id || 0,
              hours: num
            }
          }
        }
      };
    });
  };

  const openCommentModal = (date) => {
    const dateKey = date.format("YYYY-MM-DD");
    setCommentModal({
      isOpen: true,
      dateKey,
    });
    setCurrentComment(dailyComments[dateKey] || "");
  };

  const closeCommentModal = () => {
    setCommentModal({
      isOpen: false,
      dateKey: null,
    });
  };

  const saveComment = () => {
    if (!commentModal.dateKey) return;
    setDailyComments((prev) => ({
      ...prev,
      [commentModal.dateKey]: currentComment,
    }));
    closeCommentModal();
  };

  const calculateDayTotal = (date) => {
    const formatted = date.format("YYYY-MM-DD");
    let total = 0;

    Object.values(timesheet.entries).forEach((rowEntry) => {
      const value = rowEntry?.[formatted]?.hours;

      if (!value || Number(value) === 0) return;

      total += Number(value);
    });

    return total;
  };

  // const isSubmitEnabled = useMemo(() => {
  //   const isCurrentMonth =
  //     selectedMonth.month() === today.month() &&
  //     selectedMonth.year() === today.year();

  //   const isLastDay = today.date() === daysInMonth;

  //   if (isCurrentMonth && isLastDay) return true;
  //   if (selectedMonth.isBefore(today, "month")) return true;

  //   return false;
  // }, [selectedMonth, today, daysInMonth]);

  const isSubmitEnabled = useMemo(() => {

    const lastWorkingDay = [...daysArray]
      .reverse()
      .find(date =>
        !isSunday(date) &&
        !isHoliday(date) &&
        !isWeekOff(date) &&
        !isLeave(date)
      );

    if (!lastWorkingDay) return false;

    return today.isSame(lastWorkingDay, "day") || today.isAfter(lastWorkingDay, "day");

  }, [daysArray, today, isHoliday, isWeekOff, isLeave]);


  useEffect(() => {
    const apiList = timesheetData?.data?.result;

    if (!Array.isArray(apiList) || !apiList.length) return;

    const groupedRows = {};
    const newEntries = {};
    const newComments = {};
    const newDayTypes = {};

    apiList.forEach((item) => {
      const workDate = dayjs(item.work_date).format("YYYY-MM-DD");

      if (item.day_type) {
        const workDate = dayjs(item.work_date).format("YYYY-MM-DD");
        newDayTypes[workDate] = item.day_type;
      }

      // Ignore other months just in case backend sends extra
      const weekStart = currentWeekStart.format("YYYY-MM-DD");
      const weekEnd = currentWeekStart.add(6, "day").format("YYYY-MM-DD");

      if (workDate < weekStart || workDate > weekEnd) return;

      const rowKey = `${item.project_id}-${item.wbse_id}-${item.task_id}`;

      // Build rows
      if (!groupedRows[rowKey]) {
        groupedRows[rowKey] = {
          id: rowKey,
          projectId: item.project_id,
          wbseId: item.wbse_id,
          taskId: item.task_id,
          costPerHour: item.cost_per_hour || 0
        };
      }

      // Build entries and merge duplicate dates
      if (!newEntries[rowKey]) newEntries[rowKey] = {};
      // const previous = Number(newEntries[rowKey][workDate] || 0);
      // newEntries[rowKey][workDate] =
      //   previous + Number(item.hours_spent || 0);
      if (!newEntries[rowKey]) newEntries[rowKey] = {};

      newEntries[rowKey][workDate] = {
        hours: Number(item.hours_spent || 0),
        timesheet_id: item.timesheet_id
      };

      // Save comment per date
      if (item.description) {
        newComments[workDate] = item.description;
      }
    });

    setTimesheet((prev) => ({
      ...prev,
      rows: Object.values(groupedRows),
      entries: newEntries,
    }));

    setDailyComments(newComments);
    setDayTypes(newDayTypes);

  }, [timesheetData, monthKey]);


  useEffect(() => {
    if (week && year) {
      const firstDay = dayjs()
        .year(Number(year))
        .week(Number(week))
        .startOf("week")
        .add(1, "day");

      setCurrentWeekStart(firstDay);
      setSelectedMonth(firstDay);
    }
  }, [week, year]);

  useEffect(() => {
    setSelectedMonth(currentWeekStart);
  }, [currentWeekStart]);

  const totalHolidays = useMemo(() => {
    return daysArray.filter((date) => {
      const sunday = date.day() === 0;
      const holiday = dayTypes[date.format("YYYY-MM-DD")] === "holiday";
      const weekOff = userWeekOffs.includes(date.format("YYYY-MM-DD"));
      const leave = dayTypes[date.format("YYYY-MM-DD")] === "leave";

      // Holiday = Sunday OR Holiday OR WeekOff
      // but NOT leave
      return (sunday || holiday || weekOff) && !leave;
    }).length;
  }, [daysArray, dayTypes, userWeekOffs]);

  const totalLeaves = useMemo(() => {
    return daysArray.filter((date) =>
      dayTypes[date.format("YYYY-MM-DD")] === "leave"
    ).length;
  }, [daysArray, dayTypes]);

  const totalWorkingDays = useMemo(() => {
    return daysArray.length - totalHolidays - totalLeaves;
  }, [daysArray.length, totalHolidays, totalLeaves]);

  // const isCompleted = ["submitted", "approved"].includes(timesheet.status);
  const isCompleted =
    timesheetData?.data?.result?.[0]?.approval_status === "approved";

  const validateForm = () => {
    for (const date of daysArray) {
      if (isFuture(date)) continue;
      if (isSunday(date) || isHoliday(date) || isWeekOff(date) || isLeave(date)) {
        continue;
      }
      if (calculateDayTotal(date) <= 0) {
        return false;
      }
    }
    return true;
  };

  // const handleSave = async (status) => {
  //   console.log("handleSave called with status:", status);
  //   try {
  //     if (isCompleted) return;
  //     if (String(status) === "2" && !isSubmitEnabled) return;

  //     if (String(status) === "2") {
  //       const isValid = validateForm();
  //       if (!isValid) {
  //         alert(
  //           "Please fill timesheet entries for all working days before submitting."
  //         );
  //         return;
  //       }
  //     }

  //     if (String(status) === "1") {
  //       for (const row of timesheet.rows) {
  //         const rowEntries = timesheet.entries[row.id] || {};
  //         // for (const [work_date, hours] of Object.entries(rowEntries))
  //         for (const [work_date, entry] of Object.entries(rowEntries)) {
  //           // if (Number(hours) > 0) 
  //           {
  //             const payload = {
  //               month: monthKey,
  //               timesheet_status: "draft",
  //               project_id: row.projectId,
  //               wbse_id: row.wbseId,
  //               task_id: row.taskId,
  //               work_date,
  //               hours_spent: hours,
  //               cost_per_hour: row.costPerHour || 0,
  //               description: dailyComments?.[work_date] || "",
  //               approval_status: "pending",
  //             };

  //             addTimesheet.mutate(payload);
  //           }
  //         }
  //       }
  //     }

  //     if (String(status) === "2") {
  //       for (const row of timesheet.rows) {
  //         const rowEntries = timesheet.entries[row.id] || {};
  //         for (const [work_date, hours] of Object.entries(rowEntries)) {
  //           if (Number(hours) > 0) {
  //             const payload = {
  //               month: monthKey,
  //               timesheet_status: "submitted",
  //               project_id: row.projectId,
  //               wbse_id: row.wbseId,
  //               task_id: row.taskId,
  //               work_date,
  //               hours_spent: hours,
  //               cost_per_hour: row.costPerHour || 0,
  //               description: dailyComments?.[work_date] || "",
  //               approval_status: "pending",
  //             };

  //             addTimesheet.mutate(payload);
  //           }
  //         }
  //       }
  //     }

  //     setTimesheet((prev) => ({
  //       ...prev,
  //       status: String(status) === "2" ? "submitted" : "draft",
  //     }));
  //   } catch (error) {
  //     alert("Something went wrong while submitting timesheet");
  //   }
  // };

  const handleSave = async (status) => {
    try {
      if (isCompleted) return;
      if (String(status) === "2" && !isSubmitEnabled) return;

      // if (String(status) === "2") {
      //   const isValid = validateForm();
      //   if (!isValid) {
      //     alert("Please fill timesheet entries for all working days before submitting.");
      //     return;
      //   }
      // }

      const timesheetEntries = [];

      for (const row of timesheet.rows) {
        const rowEntries = timesheet.entries[row.id] || {};

        for (const [work_date, entry] of Object.entries(rowEntries)) {
          const dateType = dayTypes?.[work_date];

          if (dateType === "leave" || dateType === "holiday") {
            timesheetEntries.push({
              timesheet_id: entry.timesheet_id || 0,
              project_id: row.projectId,
              wbse_id: row.wbseId,
              task_id: row.taskId,
              work_date,
              hours_spent: 0,
              cost_per_hour: row.costPerHour || 0,
              description: "",
              day_type: dateType
            });
            continue;
          }

          if (!entry?.hours || Number(entry.hours) <= 0) continue;

          timesheetEntries.push({
            timesheet_id: entry.timesheet_id || 0,
            project_id: row.projectId,
            wbse_id: row.wbseId,
            task_id: row.taskId,
            work_date,
            hours_spent: entry.hours,
            cost_per_hour: row.costPerHour || 0,
            // description: dailyComments?.[work_date] || "",
            description: approveAccess ? timesheet.description : (dailyComments?.[work_date] || ""),
            day_type: dayTypes?.[work_date] || null
          });
        }
      }

      let timesheet_status = "draft";
      let approval_status = "pending";

      /* Employee */
      if (status === 1) timesheet_status = "draft";
      if (status === 2) timesheet_status = "submitted";

      /* Supervisor */
      if (canApprove) {
        approval_status = timesheet.status; // approved/rejected
        timesheet_status = "submitted";
      }
      const payload = {
        month: monthKey,
        timesheet_status,
        approval_status,
        entries: timesheetEntries,
        deleted_ids: deletedRows,
        day_types: dayTypes
      };
      addTimesheet.mutate(payload);

      setTimesheet((prev) => ({
        ...prev,
        status: String(status) === "2" ? "submitted" : "draft",
      }));

    } catch (error) {
      alert("Something went wrong while submitting timesheet");
    }
  };


  const handleApprove = () => {
    const payload = {
      user_id: userIdFromParams,
      week,
      year,
      approval_status: timesheet.status // "approved" or "rejected"
    };

    approveTimesheet.mutate(payload, {
      onSuccess: () => {
        alert("Timesheet updated successfully");
      }
    });
  };

  return (
    <PageLayout title="Timesheet">
      <CardLayout>
        <div style={{
          padding: "10px 15px",
          background: "#f5f7fb",
          borderRadius: "6px",
          marginBottom: "10px",
          fontWeight: "600"
        }}>
          Timesheet for : <span style={{ color: "#6262ca" }}> {userName || "Loading..."}</span>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); }}>
          <Row className="mb-2 align-items-center">

            <Col md={3}>
              <label style={{ display: "block", marginBottom: 6 }}>Month</label>
              <input
                type="month"
                className="form-control form-control-sm"
                value={selectedMonth.format("YYYY-MM")}
                onChange={(e) => {
                  if (e.target.value) {
                    const newMonth = dayjs(e.target.value + "-01");
                    setSelectedMonth(newMonth);

                    const firstWeek = newMonth.startOf("week").add(1, "day");
                    setCurrentWeekStart(firstWeek);
                  }
                }}
              />
            </Col>
            {!approveAccess || !canApprove && <Col lg={2}> </Col>}
            {canApprove && !isApproved && (
              <Col md={3} style={{ display: "block", marginTop: 9 }}>
                <SelectDropdown
                  label="Approver Status"
                  name="status"
                  value={timesheet.status}
                  values={{ status: timesheet.status }}
                  options_data={STATUS_OPTIONS}
                  setValues={(nextValues) =>
                    setTimesheet((prev) => ({
                      ...prev,
                      status: nextValues.status,
                    }))
                  }
                />
              </Col>
            )}

            {/* {canApprove &&
              <Col md={3} style={{ display: "block", marginTop: 9 }}>
                <SelectDropdown
                  label="Approver Status"
                  name="status"
                  value={timesheet.status}
                  values={{ status: timesheet.status }}
                  options_data={STATUS_OPTIONS}
                  setValues={(nextValues) =>
                    setTimesheet((prev) => ({
                      ...prev,
                      status: nextValues.status,
                    }))
                  }
                />
              </Col>} */}

            {/* <Col md={3}>
            <SelectDropdown
              label="Select Project"
              name="status"
              value={timesheet.status}
              values={{ status: timesheet.status }}
              options_data={STATUS_OPTIONS}
              setValues={(nextValues) =>
                setTimesheet((prev) => ({
                  ...prev,
                  status: nextValues.status,
                }))
              }
            />
          </Col> */}
            {/* </Row>
<Row className="mb-3"> */}


            <Col md={2} className="d-flex justify-content-center">

              <div
                style={{
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  padding: "6px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  background: "#f8f9fa"
                }}
              >
                <Button
                  size="sm"
                  color="light"
                  style={{ border: "1px solid #dee2e6" }}
                  // onClick={() => setWeekOffset(prev => prev - 1)}
                  //                   onClick={() => {
                  //   const newOffset = weekOffset - 1;
                  //   setWeekOffset(newOffset);

                  //   const newWeekStart = daysArray[0].add(-7, "day");
                  //   setSelectedMonth(newWeekStart);
                  // }}
                  // onClick={() => {
                  //   const prevWeek = currentWeekStart.subtract(7, "day");
                  //   setCurrentWeekStart(prevWeek);
                  //   setSelectedMonth(prevWeek);
                  // }}
                  onClick={() => {
                    setCurrentWeekStart(prev =>
                      prev.subtract(7, "day")
                    );
                  }}
                >
                  ❮
                </Button>

                <div style={{ fontWeight: 600, minWidth: "130px", textAlign: "center" }}>
                  {daysArray[0].format("DD MMM")} - {daysArray[6].format("DD MMM")}
                </div>

                <Button
                  size="sm"
                  color="light"
                  style={{ border: "1px solid #dee2e6" }}
                  // onClick={() => setWeekOffset(prev => prev + 1)}
                  //                   onClick={() => {
                  //   const newOffset = weekOffset + 1;
                  //   setWeekOffset(newOffset);

                  //   const newWeekStart = daysArray[0].add(7, "day");
                  //   setSelectedMonth(newWeekStart);
                  // }}
                  // onClick={() => {
                  //   const nextWeek = currentWeekStart.add(7, "day");
                  //   setCurrentWeekStart(nextWeek);
                  //   setSelectedMonth(nextWeek);
                  // }}
                  onClick={() => {
                    setCurrentWeekStart(prev =>
                      prev.add(7, "day")
                    );
                  }}
                >
                  ❯
                </Button>
              </div>

            </Col>
            <Col lg={2}> </Col>
            <Col lg={2} className="d-flex justify-content-end">
              <Button color="primary" onClick={handleAddRow} disabled={!canEditTimesheet}>
                + Add Row
              </Button>
            </Col>

          </Row>
          {/* <Col lg={12} className="d-flex justify-content-end">
              <Button color="primary" onClick={handleAddRow}>
                + Add Row
              </Button>
            </Col>
          </Row> */}
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered">
              <TimesheetHeader
                days={daysArray}
                today={today}
                isHoliday={isHoliday}
                isWeekOff={isWeekOff}
                isSunday={isSunday}
              />

              <tbody>
                {timesheet.rows
                  .filter(row => {
                    const rowEntries = timesheet.entries[row.id] || {};

                    // ✅ Always show empty/new rows
                    if (Object.keys(rowEntries).length === 0) return true;

                    return Object.values(rowEntries).some(e => {
                      const hours = Number(e?.hours);
                      const dayType = e?.day_type;

                      return hours > 0 && !dayType;
                    });
                  })
                  .map((row) => (
                    <TimesheetRow
                      key={row.id}
                      row={row}
                      days={daysArray}
                      entries={timesheet.entries}
                      projectOptions={projectOptions}
                      onChange={handleChange}
                      onRowMetaChange={handleRowMetaChange}
                      isCellDisabled={isCellDisabled}
                      isHoliday={isHoliday}
                      isLeave={isLeave}
                      isOptionalHoliday={isOptionalHoliday}
                      dayTypes={dayTypes}
                      isSunday={isSunday}
                      sundayOverrides={sundayOverrides}
                      holidayOverrides={holidayOverrides}
                      onSundayClick={handleSundayClick}
                      handleHolidayClick={handleHolidayClick}
                      onRemoveRow={handleRemoveRow}
                      canEdit={canEditTimesheet}
                      isSupervisorViewingOther={isSupervisorViewingOther}
                      onDeleteRow={handleDeleteRow}
                      setDeletedRows={setDeletedRows}
                    />
                  ))}

                {/* <TimesheetCommentsRow
                days={daysArray}
                dailyComments={dailyComments}
                onOpen={openCommentModal}
              /> */}

                <TimesheetDayTypeRow
                  days={daysArray}
                  dayTypes={dayTypes}
                  onChange={handleDayTypeChange}
                />

                <TimesheetTotals
                  days={daysArray}
                  calculateDayTotal={calculateDayTotal}
                  dayTypes={dayTypes}
                  isLeave={isLeave}
                  isHoliday={isHoliday}
                  isSunday={isSunday}
                  isWeekOff={isWeekOff}
                />
              </tbody>
            </table>
          </div>
          {/* <Modal isOpen={commentModal.isOpen} toggle={closeCommentModal}>
          <ModalHeader toggle={closeCommentModal}>
            Comment for {commentModal.dateKey}
          </ModalHeader>
          <ModalBody>
            <textarea
              className="form-control"
              rows="5"
              value={currentComment}
              onChange={(e) => setCurrentComment(e.target.value)}
              placeholder="Enter work description..."
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={closeCommentModal}>
              Cancel
            </Button>
            <Button color="primary" onClick={saveComment}>
              Save
            </Button>
          </ModalFooter>
        </Modal> */}

          <Row className="mt-3 mb-3 justify-content-center">
            <Col lg={8} style={{ maxWidth: 600 }}>
              <table className="table table-bordered mb-0">
                <tbody>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Total Holidays</td>
                    <td>{totalHolidays}</td>
                    <td style={{ fontWeight: 600 }}>Total Leaves</td>
                    <td>{totalLeaves}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Total Working Days (in this week)</td>
                    <td>{totalWorkingDays}</td>
                    <td style={{ fontWeight: 600 }}>Total Calendar Days</td>
                    <td>{daysInMonth}</td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col lg={12}>
              {approveAccess &&
                <TextArea
                  label="Comments"
                  name="description"
                  isrequired={true}
                  value={timesheet.description}
                  onChange={(e) =>
                    setTimesheet(prev => ({
                      ...prev,
                      description: e.target.value
                    }))
                  }

                // value={values.description}
                // onChange={handleChange}
                />
              }


            </Col>
            <Col lg={5}>
              {canEditTimesheet && !isSupervisorViewingOther &&
                <CustomButton
                  handleSubmit={() => handleSave(1)}
                  disabled={isCompleted}
                  loading={false}
                  label="Save As Draft"
                />
              }

            </Col>
            <Col lg={5}></Col>
            <Col lg={2}>
              {!isSupervisorViewingOther &&
                <CustomButton
                  handleSubmit={() => handleSave(2)}
                  disabled={!isSubmitEnabled || isCompleted}
                  loading={false}
                  label="Submit"
                />}

              {/* {canApprove && (
                <CustomButton 
                label="Approve"
                handleSubmit={() => handleSave(2)}
                  disabled={!isSubmitEnabled || isCompleted}
                  loading={false}
                />
              )} */}
              {canApprove && !isApproved && (
                <CustomButton
                  label="Approve"
                  handleSubmit={handleApprove}
                  loading={approveTimesheet.isLoading}
                />
              )}

            </Col>
          </Row>
        </form>
      </CardLayout>
    </PageLayout>
  );
};

export default TimesheetPage;
